module.exports = __webpack_public_path__ + "static/media/223-turks-and-caicos.215dbefa.svg";